import React from 'react';
import ReactDOM from 'react-dom';
import '@shopify/polaris/build/esm/styles.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n'; // import i18n (needs to be bundled)
import './index.css';

const isInstallationNeeded = window.top === window.self;

if (isInstallationNeeded) {
  window.location.replace(window.location.origin + '/oauth' + window.location.search);
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
